module.exports = __webpack_public_path__ + "img/app-phones.d9e194fb.png";